import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { TextareaComponent } from 'component/Textarea';

export const Description = (props) => {
  const hazardType = props.formData.info.hazard_type;
  const subId = props.formData?.info?._schema_version === 2 ? '3.11' : '3.9';

  return (
    <AccordionBodyItem
      accordionSubId={subId}
      titleUA="Опис типу забруднення (за потреби)"
      titleEN="Description of the type of contamination"
      children={(
        <TextareaComponent
          id="description"
          name="description"
          value={hazardType.description}
          handleTextarea={props.handleContaminationDescription}
          disable="false"
        />
      )}
    />
  );
};
